import { Injectable } from "@angular/core";
import { ShellDomainProvider } from "../utility/shell-domain.provider";
import { HttpHeaders, HttpClient } from "@angular/common/http";

@Injectable()
export class EcapTwoFactorService {

    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    constructor(private http: HttpClient) {
    }
    sendTwoFaCode(payload): any {
        return this.http.post(ShellDomainProvider['api'].TwoFaService + '2FactorAuthentication/TwoFaCommand/Send2FactorAuthenticationCodeToPerson',
            payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
   
}